import PropTypes from "prop-types";
import React from "react";
import { FormControl, InputGroup, Overlay } from "react-bootstrap";
import $ from "jquery";

import DateHelper from "../utils/DateHelper";
import DatePickerCalendar from "../utils/DatePickerCalendar";

export default class DatePicker extends React.Component
{
	constructor(props)
	{
		super(props);

		var dateValues = this.makeDateValues(this.props.value || this.props.defaultValue);
		this.state = {
			value: dateValues.value,
			displayDate: dateValues.displayDate,
			selectedDate: dateValues.selectedDate,
			inputValue: dateValues.inputValue,
			focused: false,
			inputFocused: false
		};

		this.makeDateValues = this.makeDateValues.bind(this);
		this.clear = this.clear.bind(this);
		this.handleHide = this.handleHide.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.preventClose = this.preventClose.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.setFocusFalse = this.setFocusFalse.bind(this);
		this.getValue = this.getValue.bind(this);
		this.getFormattedValue = this.getFormattedValue.bind(this);
		this.makeInputValueString = this.makeInputValueString.bind(this);
		this.handleBadInput = this.handleBadInput.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onChangeMonth = this.onChangeMonth.bind(this);
		this.onChangeDate = this.onChangeDate.bind(this);

		this.dateInputSelectionStart = 0;
		this.dateInputSelectionEnd = 0;
	}

	makeDateValues(isoString)
	{
		var displayDate;
		var selectedDate = isoString instanceof Date
			? (isNaN(isoString.getTime()) ? null : isoString)
			: (isoString ? DateHelper.getDate(isoString) : null);
		if (selectedDate && isNaN(selectedDate.getTime()))
		{
			selectedDate = null;
		}
		var inputValue = selectedDate ? this.makeInputValueString(selectedDate) : null;
		if (selectedDate)
		{
			displayDate = new Date(Date.UTC(
				selectedDate.getUTCFullYear(),
				selectedDate.getUTCMonth(),
				selectedDate.getUTCDate()
			));
		}
		else
		{
			displayDate = new Date(Date.UTC(
				new Date().getUTCFullYear(),
				new Date().getUTCMonth(),
				new Date().getUTCDate()
			));
		}

		return {
			value: selectedDate ? selectedDate.toISOString() : null,
			displayDate: displayDate,
			selectedDate: selectedDate,
			inputValue: inputValue
		};
	}

	clear()
	{
		if (this.props.onClear)
		{
			this.props.onClear();
		}
		else
		{
			this.setState(this.makeDateValues(null));
		}

		if (this.props.onChange)
		{
			this.props.onChange(null, null);
		}
	}

	handleHide()
	{
		if (this.state.inputFocused)
		{
			return;
		}
		this.setState(
			{
				focused: false
			});
	}

	handleKeyDown(event)
	{
		this.setDateInputSelectionRangeVariables(this.dateInput);
		if (event.key === "Tab" && this.state.inputFocused)
		{
			this.setState(
				{
					focused: false
				});

			if (this.props.onBlur)
			{
				var blurEvent = document.createEvent("CustomEvent");
				blurEvent.initEvent("Change Date", true, false);
				this.hiddenInput.dispatchEvent(blurEvent);
				this.props.onBlur(blurEvent);
			}
		}
		if (this.state.showDatePickerCalendar === true)
		{
			var dateModifier = 0;
			switch (event.key)
			{
				case "ArrowUp":
					dateModifier = -7;
					break;
				case "ArrowDown":
					dateModifier = 7;
					break;
				case "ArrowRight":
				case "+":
				case "=":
					dateModifier = 1;
					break;
				case "ArrowLeft":
				case "-":
					dateModifier = -1;
					break;
				case "Escape":
					this.setState(
						{
							showDatePickerCalendar: false
						});
					break;
			}

			if (dateModifier !== 0)
			{
				event.preventDefault();
				let date = this.state.selectedDate;
				date.setDate(date.getDate() + dateModifier);

				this.dateInputSelectionStart = 10;
				this.dateInputSelectionEnd = 10;

				this.onChangeDate(date);
			}
		}
		else if (this.state.selectedDate && event.target.value)
		{
			let modifier = 0;
			switch(event.key)
			{
				case "ArrowUp":
				case "+":
				case "=":
					modifier = 1;
					break;
				case "ArrowDown":
				case "-":
					modifier = -1;
					break;
			}

			if (modifier === 0)
			{
				return;
			}

			if (!this.state.value)
			{
				return;
			}

			let date = this.makeDateValues(this.state.value).selectedDate;

			const dateFirst = this.props.dateFormat.match(/DD.MM.YYYY/);
			const monthFirst = this.props.dateFormat.match(/MM.DD.YYYY/);

			if (event.key === "+" || event.key === "=" || event.key === "-")
			{
				date.setDate(date.getDate() + modifier);
			}
			else if (dateFirst || monthFirst)
			{
				if (this.dateInputSelectionStart >= 0 && this.dateInputSelectionEnd <= 2)
				{
					if (monthFirst)
					{
						date.setMonth(date.getMonth() + modifier);
					}
					if (dateFirst)
					{
						date.setDate(date.getDate() + modifier);
					}
				}
				if (this.dateInputSelectionStart >= 3 && this.dateInputSelectionEnd <= 5)
				{
					if (monthFirst)
					{
						date.setDate(date.getDate() + modifier);
					}
					if (dateFirst)
					{
						date.setMonth(date.getMonth() + modifier);
					}
				}
				if (this.dateInputSelectionStart >= 6 && this.dateInputSelectionEnd >= 6)
				{
					date.setFullYear(date.getFullYear() + modifier);
				}
			}
			else
			{
				if (this.dateInputSelectionStart >= 0 && this.dateInputSelectionEnd <= 4)
				{
					date.setFullYear(date.getFullYear() + modifier);
				}
				if (this.dateInputSelectionStart >= 5 && this.dateInputSelectionEnd <= 7)
				{
					date.setMonth(date.getMonth() + modifier);
				}
				if (this.dateInputSelectionStart >= 8 && this.dateInputSelectionEnd >= 8)
				{
					date.setDate(date.getDate() + modifier);
				}
			}

			if (date.getTime() !== (this.makeDateValues(this.state.value)).selectedDate.getTime())
			{
				event.preventDefault();
				this.onChangeDate(date);
			}
		}

	}

	setDateInputSelectionRangeVariables(dateInput)
	{
		if (!dateInput)
		{
			return;
		}
		this.dateInputSelectionStart = dateInput.selectionStart;
		this.dateInputSelectionEnd = dateInput.selectionEnd;
	}

	preventClose()
	{
		clearTimeout(this.blurFocusTimeout);
		this.dateInput.focus();
		this.dateInput.setSelectionRange(this.dateInputSelectionStart, this.dateInputSelectionEnd);
	}

	handleFocus()
	{
		clearTimeout(this.blurFocusTimeout);
		if (this.state.focused !== true)
		{
			this.setDateInputSelectionRangeVariables(this.dateInput);
			this.setState(
				{
					inputFocused: true
				});
		}

		if (this.props.onFocus)
		{
			var event = document.createEvent("CustomEvent");
			event.initEvent("Change Date", true, false);
			this.hiddenInput.dispatchEvent(event);
			this.props.onFocus(event);
		}
	}

	handleClick()
	{
		if (this.state.showDatePickerCalendar !== true)
		{
			this.setDateInputSelectionRangeVariables(this.dateInput);
			this.setState(
				{
					showDatePickerCalendar: true
				});
		}

		if (this.props.onClick)
		{
			var event = document.createEvent("CustomEvent");
			event.initEvent("Change Date", true, false);
			this.hiddenInput.dispatchEvent(event);
			this.props.onClick(event);
		}
	}

	handleBlur()
	{
		clearTimeout(this.blurFocusTimeout);
		this.blurFocusTimeout = setTimeout(() => {
			this.handleInputChange();
			this.setFocusFalse();
			if (this.props.onBlur)
			{
				var blurEvent = document.createEvent("CustomEvent");
				blurEvent.initEvent("Change Date", true, false);
				this.hiddenInput.dispatchEvent(blurEvent);
				this.props.onBlur(blurEvent);
			}
		}, 175);
	}

	setFocusFalse()
	{
		this.setState(
			{
				inputFocused: false,
				showDatePickerCalendar: false
			});
	}

	getValue()
	{
		return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	}

	getFormattedValue()
	{
		return this.state.displayDate ? this.state.inputValue : null;
	}

	makeInputValueString(date)
	{
		var month = date.getUTCMonth() + 1;
		var day = date.getUTCDate();
		var year = date.getUTCFullYear();

		var separator = (this.props.dateFormat.match(/[^A-Z]/)[0]);
		if (this.props.dateFormat.match(/MM.DD.YYYY/))
		{
			return (month > 9 ? month : `0${month}`) + separator + (day > 9 ? day : `0${day}`) + separator + year;
		}
		else if (this.props.dateFormat.match(/DD.MM.YYYY/))
		{
			return (day > 9 ? day : `0${day}`) + separator + (month > 9 ? month : `0${month}`) + separator + year;
		}
		else
		{
			return year + separator + (month > 9 ? month : `0${month}`) + separator + (day > 9 ? day : `0${day}`);
		}
	}

	handleBadInput(originalValue)
	{
		var parts = originalValue.replace(new RegExp(`[^0-9${this.separator}]`), "").split(this.separator);
		if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/))
		{
			if (parts[0] && parts[0].length > 2)
			{
				parts[1] = parts[0].slice(2) + (parts[1] || "");
				parts[0] = parts[0].slice(0, 2);
			}
			if (parts[1] && parts[1].length > 2) {
				parts[2] = parts[1].slice(2) + (parts[2] || "");
				parts[1] = parts[1].slice(0, 2);
			}
			if (parts[2])
			{
				parts[2] = parts[2].slice(0, 4);
			}
		}
		else
		{
			if (parts[0] && parts[0].length > 4) {
				parts[1] = parts[0].slice(4) + (parts[1] || "");
				parts[0] = parts[0].slice(0, 4);
			}
			if (parts[1] && parts[1].length > 2) {
				parts[2] = parts[1].slice(2) + (parts[2] || "");
				parts[1] = parts[1].slice(0, 2);
			}
			if (parts[2]) {
				parts[2] = parts[2].slice(0, 2);
			}
		}
		this.setState(
			{
				inputValue: parts.join(this.separator)
			});
	}

	handleInputChange()
	{
		this.setDateInputSelectionRangeVariables(this.dateInput);
		const originalValue = this.dateInput.value;
		const inputValue = originalValue.replace(new RegExp(`[^0-9${this.separator}]`), this.separator).slice(0, 10);
		const hasChanged = this.state.inputValue !== inputValue;

		let month, day, year;
		if (this.props.dateFormat.match(/MM.DD.YYYY/))
		{
			if (!inputValue.match(/^[0-1]?[0-9].[0-3]?[0-9].([1-2][0-9])?[0-9][0-9]$/))
			{
				return this.handleBadInput(originalValue);
			}

			let dateParts = inputValue.split(this.separator);

			month = dateParts[0];
			day = dateParts[1];
			year = dateParts[2];
		}
		else if (this.props.dateFormat.match(/DD.MM.YYYY/))
		{
			if (!inputValue.match(/^[0-3]?[0-9].[0-1]?[0-9].([1-2][0-9])?[0-9][0-9]$/)) {
				return this.handleBadInput(originalValue);
			}

			let dateParts = inputValue.split(this.separator);

			day = dateParts[0];
			month = dateParts[1];
			year = dateParts[2];
		}
		else
		{
			if (!inputValue.match(/^([1-2][0-9])?[0-9][0-9].[0-1]?[0-9].[0-3]?[0-9]$/)) {
				return this.handleBadInput(originalValue);
			}

			let dateParts = inputValue.split(this.separator);

			year = dateParts[0];
			month = dateParts[1];
			day = dateParts[2];
		}

		const monthInteger = parseInt(month, 10);
		const dayInteger = parseInt(day, 10);
		const yearInteger = parseInt(year, 10);
		if (monthInteger > 12 || dayInteger > 31)
		{
			return this.handleBadInput(originalValue);
		}

		if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999)
		{
			const selectedDate = new Date(Date.UTC(yearInteger, monthInteger - 1, dayInteger, 0, 0, 0, 0));
			this.setState(
				{
					selectedDate: selectedDate,
					displayDate: selectedDate,
					value: selectedDate.toISOString()
				});

			if (this.props.onChange && hasChanged)
			{
				this.props.onChange(selectedDate.toISOString(), inputValue);
			}
		}

		this.setState(
			{
				inputValue: inputValue
			});
	}

	onChangeMonth(newDisplayDate)
	{
		this.setState(
			{
				displayDate: newDisplayDate
			});
	}

	onChangeDate(newSelectedDate)
	{
		const inputValue = this.makeInputValueString(newSelectedDate);
		const hasChanged = this.state.inputValue !== inputValue;
		if (this.dateInput)
		{
			this.setDateInputSelectionRangeVariables(this.dateInput);
		}

		this.setState(
			{
				inputValue: inputValue,
				selectedDate: newSelectedDate,
				displayDate: newSelectedDate,
				value: newSelectedDate.toISOString()
			});

		if (this.props.onChange && hasChanged)
		{
			this.props.onChange(newSelectedDate.toISOString(), inputValue);
		}
	}

	componentWillReceiveProps(newProps)
	{
		var value = newProps.value;
		if (this.getValue() !== value)
		{
			this.setState(this.makeDateValues(value));
		}
	}

	componentDidMount()
	{
		this.separator = this.props.dateFormat.match(/[^A-Z]/)[0];

		this.dateInput.setSelectionRange(this.dateInputSelectionStart, this.dateInputSelectionEnd);
	}

	componentWillUnmount()
	{
		clearTimeout(this.blurFocusTimeout);
	}

	componentDidUpdate()
	{
		if (this.dateInput && $(this.dateInput).is(":focus"))
		{
			this.dateInput.setSelectionRange(this.dateInputSelectionStart, this.dateInputSelectionEnd);
		}
	}

	render()
	{
		const { showClearButton, calendarPlacement, dateFormat, ...rest } = this.props;
		const control = <FormControl
			{...rest}
			onBlur={this.handleBlur}
			onChange={this.handleInputChange}
			onClick={this.handleClick}
			onFocus={this.handleFocus}
			onKeyDown={this.handleKeyDown}
			placeholder={this.state.focused ? dateFormat : this.props.placeholder}
			inputRef={(input) => { this.dateInput = input; }}
			type="text"
			value={this.state.inputValue || ""}
		/>;
		const overlayContainer = <div
			ref={(div) => { this.overlayContainer = div; }}
			style={{ position: "relative" }}
		/>;
		const hiddenInput = <input
			ref={(input) => { this.hiddenInput = input; }}
			type="hidden"
			id={this.props.id}
			name={this.props.name}
			value={this.state.value || ""}
			data-formattedvalue={this.state.value ? this.state.inputValue : ""}
		/>;
		return (
			<InputGroup
				ref={(inputGroup) => { this.inputGroup = inputGroup; }}
				bsClass={showClearButton ? this.props.bsClass : ""}
				bsSize={this.props.bsSize}
				id={this.props.id ? `${this.props.id}_group` : null}>
				<Overlay
					show={this.state.showDatePickerCalendar}
					container={this.props.calendarContainer || this.overlayContainer}
					target={this.dateInput}
					placement={calendarPlacement}
					onClick={this.preventClose}
				>
					<DatePickerCalendar
						{...rest}
						selectedDate={this.state.selectedDate}
						displayDate={this.state.displayDate}
						onChangeMonth={this.onChangeMonth}
						onChangeSelectedDate={this.onChangeDate}
						onKeyDown={this.handleKeyDown}
						dayLabels={this.state.dayLabels}
						preventClose={this.preventClose}
						calendarPlacement={calendarPlacement}
					/>
				</Overlay>
				{overlayContainer}
				{hiddenInput}
				{control}
				{showClearButton && <InputGroup.Addon
					onClick={this.props.disabled ? null : this.clear}
					style={{ cursor: (this.state.inputValue && !this.props.disabled) ? "pointer" : "not-allowed" }}>
					<div style={{ opacity: (this.state.inputValue && !this.props.disabled) ? 1 : 0.5 }}>
						{this.props.clearButtonElement}
					</div>
				</InputGroup.Addon>}
			</InputGroup>
		);
	}
}

var language = typeof window !== "undefined" && window.navigator ? (window.navigator.userLanguage || window.navigator.language || "").toLowerCase() : "";
var dateFormat = !language || language === "en-us" ? "MM/DD/YYYY" : "DD/MM/YYYY";

DatePicker.defaultProps = {
	autoFocus: false,
	calendarPlacement: "bottom",
	cellPadding: "5px",
	dateFormat: dateFormat,
	value: new Date().toISOString(),
	disabled: false,
	placeholder: dateFormat,
	showClearButton: true,
	style: {
		width: "100%"
	}
};

DatePicker.propTypes = {
	value: PropTypes.string,
	defaultValue: PropTypes.string,
	dateFormat: PropTypes.string,
	placeholder: PropTypes.string,
	name: PropTypes.string, // Goes on the hidden input
	id: PropTypes.string, // Goes on the hidden input
	bsClass: PropTypes.string,
	bsSize: PropTypes.string,
	disabled: PropTypes.bool,
	showClearButton: PropTypes.bool,
	onChange: PropTypes.func,
	onClear: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onClick: PropTypes.func,
	calendarPlacement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
	calendarContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
	clearButtonElement: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
};



// WEBPACK FOOTER //
// ./Components/utils/DatePicker.jsx